<template>
  <div id="app">
    <div class="topbar" v-if="$route.name !== 'login'">
      <TopBar />
      <!-- <Header /> -->
    </div>
    <keep-alive>
      <router-view
        class="main"
        :style="{
          'margin-top': $route.name !== 'login' ? '50px' : '0',
          'margin-bottom': $route.name !== 'login' ? '50px' : '0',
        }"
      />
      <!-- <router-view
        class="main"
        :style="{
          'margin-top': $route.name !== 'login' ? '150px' : '0',
          'margin-bottom': $route.name !== 'login' ? '50px' : '0',
        }"
      /> -->
      <Footer class="footer" v-if="$route.name !== 'login'" />
    </keep-alive>
  </div>
</template>
<script>
import TopBar from "@/components/TopBar.vue";
import Header from "@/components/Header.vue";

export default {
  name: "App",
  components: {
    TopBar,
    Header,
  },
};
</script>
<style scope lang="less">
.topbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}
</style>
